import { requestWithToken as request } from "./api";

export const uploadFiles = (data = {}) =>
    request.post("/general_file_upload/", data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

export const checkStatusFilesValidation = (kind_file) =>
    request.get(
        `/general_file_upload/validate_status/?kind_file=${kind_file}&format=json`
    );

export const getUrlsFilesHistory = () =>
    request.get(
        `/general_file_upload/get_urls_files_history/?format=json`
    );    

export const getUrlsDownloadFile = (idDownloadedFile) =>
    request.get(
        `/general_file_upload/get_url_download_file/?id_uploaded_file=${idDownloadedFile}&format=json`
    );

export const getFilesUsersByCompany = (idCompany) =>
    request.get(
        `/general_file_upload/files_by_users_company/?company_id=${idCompany}&format=json`
    );
